/* eslint-disable no-nested-ternary */
import { NavigationType } from '@/components/navigation/NavigationIntroScreen/components/Popup/NavigationIntroChoicePopup';
import { getQueryVariable } from '@/components/util/all';
import { getClosestSweepFromObject } from '../flows/utils/getClosestSweep';

export type TSetNavigationDestinationParams = {
  navigationSettings: any;
  setSliderValue: any;
  navigationType: NavigationType;
  startingLocation?: any;
  finishingLocation?: any;
  preLoad: boolean;
};

export const convertDestinationItemToSweep = ({
  item,
  allSweeps,
  allTags,
}: {
  item: any;
  allSweeps: any[];
  allTags?: any[];
}) => {
  let updated = null;
  if (item?.tag) {
    const { closestSweep } = getClosestSweepFromObject({ allSweeps, target: item.tag });
    const foundTag = allTags?.find(
      (t: any) => t.sid === item?.tag?.sid || t.defaultSid === item?.tag?.sid,
    );
    updated = {
      ...closestSweep,
      tag: foundTag || item.tag,
      isTag: true,
      enableNavBar: foundTag.enableNavBar || item.tag.enableNavBar,
      autoNavigation: foundTag.autoNavigation || item.tag.autoNavigation,
      navigationAutoPlay: foundTag.navigationAutoPlay || item.tag.navigationAutoPlay,
    };
  } else if (item?.url) {
    const queryParams = new URLSearchParams(item?.url.split('?')[1]);
    // Extract the value of 's'
    const sValue = queryParams.get('s');
    const foundSweep = allSweeps?.find((s: any) => s.sweep_uuid === sValue || s.sweepId === sValue);
    updated = { ...foundSweep, station: item, enableNavBar: true, autoNavigation: true };
  } else {
    updated = { ...item, enableNavBar: true, autoNavigation: true };
  }
  return updated;
};

export async function setNavigationDestination({
  startingLocation,
  finishingLocation,
  navigationSettings,
  setSliderValue,
  navigationType = NavigationType.Shortest,
  preLoad = false,
}: TSetNavigationDestinationParams) {
  const allTagsArray = Array.from(this.state.allTags, ([, value]: any) => value);
  const allSweepsArray = Array.from(this.state.allSweeps, ([, value]: any) => value);
  const url = window.location.href;
  const s = getQueryVariable(url, 's');

  if (!s) {
    // disable for now
    // await this.showCaseTemp.showcase.Sweep.current.waitUntil((currentSweep) => currentSweep.id !== '');
  }
  if (!allTagsArray.length || !this.state.currentSweep) {
    return;
  }

  const { navigationTarget } = this.state;
  if (
    navigationTarget &&
    finishingLocation?.tag &&
    navigationTarget.sid !== finishingLocation?.tag?.sid &&
    navigationTarget.defaultSid !== finishingLocation?.tag?.sid
  ) {
    this.showcase.Tag.close(navigationTarget.sid);
  }
  const target = convertDestinationItemToSweep({
    item: finishingLocation,
    allSweeps: allSweepsArray,
    allTags: allTagsArray,
  });
  const startingTarget = convertDestinationItemToSweep({
    item: startingLocation,
    allSweeps: allSweepsArray,
    allTags: allTagsArray,
  });

  if (!target) {
    console.error('Target sweep not found');
    return;
  }

  let currentSID =
    this.state.currentSweep.sid || this.state.currentSweep.sweep || this.defaultSweep?.sid;

  if (this.showCaseTemp.navigationManager.currentSID)
    currentSID = this.showCaseTemp.navigationManager.currentSID;
  if (startingLocation) currentSID = startingLocation.id;

  const targetSID = target ? target?.id : null; // closestSweep ? closestSweep.id : null;
  const startingTargetSID = startingTarget ? startingTarget?.id : null; //  closestSweepForStartingTarget ? closestSweepForStartingTarget.id : null;

  if (!currentSID || !targetSID) {
    console.error('Current or Target sweep not found');
    return;
  }

  if (!currentSID) {
    console.error('Current sweep not found');
    return;
  }

  if (!this.showCaseTemp.navigationManager) {
    console.error('PathFinderLine not found');
    return;
  }

  const targetTitle = target?.tag?.title || target?.station?.title || target?.name;
  const enableNavBar = target?.enableNavBar;
  const icon = target?.tag?.iconFile
    ? `${process.env.NEXT_PUBLIC_CDN}/tours/${target?.tag?.tourId}/tags/icons/${target?.tag?.iconFile}`
    : target?.tag?.custom && target?.tag?.customIcon
      ? target?.tag?.iconColor
        ? `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${target?.tag?.customIcon}?hex=${encodeURIComponent(target?.tag?.iconColor)}&circle=${
            target?.tag?.whiteCircle
          }`
        : `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${target?.tag?.customIcon}`
      : null;
  const autoNavigation = !preLoad && target?.autoNavigation;
  const enableTeleportBtn = !preLoad && target?.tag?.enableTeleportBtn;
  const navigationAutoPlay =
    !preLoad && (target.navigationAutoPlay || navigationSettings?.autoPlayEnabled);
  // Move camera to starting point before cancel show background
  if (startingTarget && !preLoad && autoNavigation && navigationAutoPlay) {
    await this.moveToSweep(startingTarget.id, { x: 0, y: 0 }, 'INSTANT', false);
  }

  this.setState({
    startingTargetSID,
    finishingTargetSID: targetSID,
    actionPathNavbarData: {
      enableNavBar,
      destinationTitle: targetTitle,
      icon,
      autoNavigation,
      enableTeleportBtn,
    },
    isNavigationBackgroundVisible: !!preLoad,
    navigationTarget: target,
  });

  if (preLoad) {
    this.showCaseTemp.navigationManager.renderPath(
      currentSID,
      targetSID,
      targetTitle,
      target,
      navigationType,
    );
    return;
  }
  if (autoNavigation) {
    if (
      navigationAutoPlay &&
      this.showCaseTemp.navigationManager.targetObjectData?.id !== target?.id
    ) {
      if (!this.showCaseTemp.navigationManager.currentSID) {
        // start automatic navigation after sweep transition is finished
        this.showCaseTemp.showcase.Sweep.current
          .waitUntil((currentSweep) => currentSweep.id !== '')
          .then(() => {
            this.setActionPathNavbarPlayButtonType('Pause');
            const sweepToStart = this.showCaseTemp.navigationManager.currentSID || currentSID;
            this.showCaseTemp.navigationManager
              .renderPath(sweepToStart, targetSID, targetTitle, target, navigationType)
              .then(() => {
                this.showCaseTemp.navigationManager
                  .autoNavigateCurrentPath(
                    setSliderValue,
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    () => {},
                    () => {
                      this.showCaseTemp.navigationManager.inAutoNavigate = false;
                      this.setActionPathNavbarPlayButtonType('Play');
                    },
                  )
                  .catch((e) => console.error(e));
              });
          });
      } else {
        this.showCaseTemp.navigationManager.reset();
        this.showCaseTemp.navigationManager
          .renderPath(currentSID, targetSID, targetTitle, target, navigationType)
          .then(() => {
            const path = this.showCaseTemp.navigationManager.getAutonavigationPath();
            const step = parseFloat((100 / path.length).toFixed(0));

            const handleSliderValueAutoChange = () => {
              setSliderValue((prevState) => {
                const nextStep = prevState + step;
                return nextStep;
              });
            };
            this.setActionPathNavbarPlayButtonType('Pause');
            this.showCaseTemp.navigationManager
              .autoNavigateCurrentPath(
                handleSliderValueAutoChange,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                () => {},
                () => {
                  this.showCaseTemp.navigationManager.inAutoNavigate = false;
                  this.setActionPathNavbarPlayButtonType('Play');
                },
              )
              .catch((e) => console.error(e));
          });
      }
    } else {
      this.setActionPathNavbarPlayButtonType('Play');
      this.showCaseTemp.navigationManager.reset();
      if (startingTargetSID) {
        if (
          !preLoad &&
          (startingTargetSID !== this.state.currentSweep?.sid ||
            startingTargetSID !== this.state.currentSweep?.id)
        ) {
          await this.moveToSweep(startingTargetSID, { x: 0, y: 0 }, 'INSTANT', false);
        }
        this.showCaseTemp.navigationManager
          .renderPath(startingTargetSID, targetSID, targetTitle, target, navigationType)
          .then(() => {
            this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
          });
      } else {
        this.showCaseTemp.navigationManager
          .renderPath(currentSID, targetSID, targetTitle, target, navigationType)
          .then(() => {
            this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
          });
      }
    }
    return;
  }
  if (this.showCaseTemp.navigationManager) {
    if (
      this.showCaseTemp.navigationManager.targetSID !== targetSID ||
      this.showCaseTemp.navigationManager.navigationType !== navigationType
    ) {
      this.showCaseTemp.navigationManager.renderPath(
        currentSID,
        targetSID,
        targetTitle,
        target,
        navigationType,
      );
    } else {
      this.showCaseTemp.navigationManager.reset();
    }
  }
}

export async function moveToStartingPoint() {
  const { navigationStartPosition } = this.state;
  if (
    navigationStartPosition &&
    this.showCaseTemp.navigationManager.currentSID !== navigationStartPosition.s
  ) {
    const { s, x, y } = navigationStartPosition;

    await this.moveToSweep(s, { x, y }, 'INSTANT');
    if (this.showCaseTemp.navigationManager.legacyIds) {
      this.showCaseTemp.navigationManager.pathCalculationSweeps.forEach((value, key) => {
        if (value.sweep_uuid === s || value.sweep_uuid === s) {
          this.showCaseTemp.navigationManager.currentSID = key;
        }
      });
    } else {
      this.showCaseTemp.navigationManager.currentSID = s;
    }
  }

  this.setState({ actionPathFinished: false, showActionPathBar: false });
  this.setActionPathNavbarPlayButtonType('Play');
  this.showCaseTemp.navigationManager.reset();
  return true;
}
